import type { Ref } from 'vue';
import { computed, isRef, ref } from 'vue';
import type { DocumentNode } from 'graphql';
import type {
  OperationVariables,
  TypedDocumentNode,
} from '@apollo/client/core';
import type { UseMutationOptions } from '@vue/apollo-composable';
import { useMutation } from '@vue/apollo-composable';
import type { ReactiveFunction } from '@vue/apollo-composable/dist/util/ReactiveFunction.js';

declare type DocumentParameter<TResult, TVariables> =
  | DocumentNode
  | Ref<DocumentNode>
  | ReactiveFunction<DocumentNode>
  | TypedDocumentNode<TResult, TVariables>
  | Ref<TypedDocumentNode<TResult, TVariables>>
  | ReactiveFunction<TypedDocumentNode<TResult, TVariables>>;

declare type OptionsParameter<TResult, TVariables> =
  | UseMutationOptions<TResult, TVariables>
  | Ref<UseMutationOptions<TResult, TVariables>>
  | ReactiveFunction<UseMutationOptions<TResult, TVariables>>;

// REMOVE LEGACY CODE
export const useReactiveMutation = <
  TResult,
  TVariables extends OperationVariables = OperationVariables,
>(
  document: DocumentParameter<TResult, TVariables>,
  options?: OptionsParameter<TResult, TVariables>,
) => {
  const paramToRef = (param: any) => {
    if (isRef(param)) return param;
    if (typeof param === 'function') return computed(param);
    return ref(param);
  };
  const documentRef = paramToRef(document);

  // @ts-ignore
  return useMutation<TResult, TVariables>(documentRef, options);
};
